import { EnvironmentsInterface } from '@core-utils';

export const environment: EnvironmentsInterface = {
  production: false,
  api: 'https://api-dev.2xpoints.com/api/v1/',
  name: 'DEV',
  landingUrl: 'https://dev.2xp.info',
  helpHeroAppId: 'Aa7eTXxk64',
  keycloak: {
    production: true,
    oauthServerHost: 'https://auth-dev.rewardsandpoints.com',
    oauthRealm: 'two-x-points-realm',
    oauthClientId: 'two-x-points-public-cli',
    superAdminRole: 'super_user',
    responseType: 'code',
    scope: 'openid profile email offline_access onboarded_scope',
  },
};
